// extracted by mini-css-extract-plugin
export default {"start":"home_start__WcSSt","start__logo":"home_start__logo__15Iju","start__text":"home_start__text__eTNVI"};